import {CoreModule} from './core/core.module';
import {SharedModule} from './shared/shared.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {UserModule} from './user/user.module';
import {CurationModule} from './curation/curation.module';
import {AberrationsModule} from '@ispm/aberrations/aberrations.module';
import {WorkflowConfigModule} from '@ispm/workflow/workflow-config.module';
import {LayoutModule} from './layout/layout.module';
import {ThemingModule} from './theming/theming.module';
import {NotesModule} from './notes/notes.module';
import {ConfigurationModule} from './configuration/configuration.module';
import {LoginAuthModule} from './authorization/login-auth.module';
import {PatientsRoutingModule} from './pathways/patients-routing.module';
import {PanCancerModule} from '@ispm-client/modules/pan-cancer/pan-cancer.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {EventsModule} from '@ispm-client/modules/events/events.module';
import {SegmentsModule} from '@ispm-client/modules/segments/segments.module';
import {AuditModule} from './audit/audit.module';
import {AdminModule} from '@ispm/dashboard/admin/admin.module';
import {PathwaysWrapperModule} from '@ispm/test/pathways/pathways-wrapper.module';
import {ExternalAction} from './external-action/external-action.module';
import {ContextProviderModule} from '@ispm-client/modules/context-provider';
import {OrdersModule} from '@ispm-client/modules/orders/orders.module';
import {ScreeningModule} from '@ispm-client/modules/screening/screening.module';
import {SimilarPatientsModule} from "@ispm-client/modules/similar-patients";
import {NotificationModule} from "@ispm/dashboard/notification/notification.module";
import {SpecimensAndSamplesModule} from "./specimens-and-samples/specimens-and-samples.module";
import {ClinicalDashboardModule} from '@ispm-client/modules/clinical-dashboard/clinical-dashboard.module';
import {LoginModule} from "@wuitk/angular/components/login-screen";
import {DlsSharedModule} from "./dls-shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {WorklistModule} from "./worklist/worklist.module";
import {NavigationModule} from "@ispm/navigation/navigation.module";
import {IframeTestModule} from "./iframe-test/iframe-test.module";
import {MigrationModule} from "@ispm/migration/migration.module";
import {DocumentsDownloadModule} from './documents-download/documents-download.module';
import {TherapiesModule} from "@ispm/therapies/therapies.module";
import {AskAIModule} from "@ispm/dashboard/ask-ai/ask-a-i.module";

export const GENOMICS_MODULES = [
  CoreModule,
  SharedModule,
  ConfigurationModule.forRoot(),
  UserModule,
  // AdminModule,
  LayoutModule,
  MigrationModule,
  NotesModule,
  DashboardModule,
  AskAIModule,
  // CurationModule,
  AberrationsModule,
  WorkflowConfigModule,
  ThemingModule,
  PatientsRoutingModule,
  PanCancerModule, // this module required to load pan cancer dashboard GEN-26620
  AggregatorModule,
  EventsModule,
  SegmentsModule,
  PathwaysWrapperModule,
  LoginAuthModule.forRoot(),
  AuditModule, // todo: remove after set lazy loading
  ExternalAction,
  DlsSharedModule,
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  WorklistModule,
  ContextProviderModule,
  OrdersModule,
  ScreeningModule,
  SimilarPatientsModule,
  TherapiesModule,
  SpecimensAndSamplesModule,
  NotificationModule,
  NavigationModule,
  LayoutModule.forRoot(),
  ClinicalDashboardModule,
  IframeTestModule,
  DocumentsDownloadModule
];
